import { Pipe, PipeTransform } from '@angular/core';
import { QueueTypeEnum } from '../../samwebDescription/samwin/QueueTypeEnum';

@Pipe({
   name: 'toQueueType',
})
export class ToQueueTypePipe implements PipeTransform {
   transform(queueTypeId: number): QueueTypeEnum {
      return QueueTypeEnum.getQueueTypeFromSamwinValue(queueTypeId);
   }
}
